fx.ns("desktop.common.toolbar", class ToolBarUniqueStateButtons extends shared.stage.ToolBarAction{
    
    constructor(command, component, container){
        super(command, component, container);
    }

    onReady(){
        super.onReady();

        this.on("click", this.onClick);
    }

    create()
    {
        super.create();
        for (let i = 0; i < this.command.buttons.length; i++)
        {
            let component = this.addChild( new shared.stage.ToolBarButton(this.command.buttons[i], this.component, this.container) );
            this.command.buttons[i].id = component.id;
        }
        this.updateButtonState();
        this.width(120); // TODO : temporary fix
    }

    // Update button state (pushed or not) with text current alignment
    updateButtonState()
    {
        this.removeClass( this.find(".pushed"), "pushed" );

        for (let i = 0; i < this.command.buttons.length; i++)
        {
            let child = this.getChild(this.command.buttons[i].id)

            if(child){
                if(child.component.alignLeft && this.command.buttons[i].field === "alignLeft")
                {
                    child.addClass("pushed");
                }
                else if(child.component.alignCenter && this.command.buttons[i].field === "alignCenter")
                {
                    child.addClass("pushed");
                }
                else if(child.component.alignRight && this.command.buttons[i].field === "alignRight")
                {
                    child.addClass("pushed");
                }
            }
        }
        
    }

    onClick(event)
    {
        let button = fx.dom.parent(event.target, ".ToolBarButton");
        if (!button)
            return;

        this.removeClass( this.find(".pushed"), "pushed" );
        this.addClass( button, "pushed" );

    }
});
